export class EoCompletionComparison {
  id: number;
  modAbbreviation: string;
  modFleet: string;
  modNumber: string;
  modStatus: string;
  modOriginalReleaseDate: Date;
  modOriginalReleaseFiscalYear: number;
  yearsSinceRelease: number;
  monthsSinceRelease: number;
  daysSinceRelease: number;
  percentagteModRepetitive: number;
  percentageAssignmentRepetitive: number;
  mercentageModAdAlert: number;
  closedCompliedWithCount: number;
  openWithSpecCount: number;
  openNoSpecCount: number;
  progressiveCount: number;
  otherCount: number;
  totalOpenCount: number;
  runRatePerYear: number;
  yearsTilRunRateCompletion: number;
  runRateCompletionYear: number;
  effectiveRunRatePerYear: number;
  runRatePerMonth: number;
  monthsTilRunRateCompletion: number;
  runRateCompletionDateMonthRunRate: Date;
  effectiveRunRatePerMonth: number;
  bomCostPerMod: number;
  bomCostPerModAssignment: number;
  bomCostPerFiscalYear: number;
  totalBomCostRemaining: number;
  bomCostPerModAverage: number;
  bomCostPerModAverageAssignment: number;
  bomCostAveragePerFiscalYear: number;
  totalBomAverageCostRemaining: number;
  maxEstimatedRunoutDate: Date;
  daysTilRunoutMonthRunRateCompletionDate: number;
  modOriginalReleaseDateToForecastDateDays95Percentile: number;
  maxForecastDate: Date;
  modForecastDate92thPercentile: Date;
  daysTilModForecastDate92thPercentile: number;
  overdueModForecastDate92thPercentileInd: number;
  percentageComplete: number;
  percentageModReleaseToForecastWindowComplete: number;
  differenceForecastWindowPercentageComplete: number;
  differenceNegative: number;
  behindScheduleOver30Percent: number;
  behindScheduleUnder30PercentWithin2Years: number;
  behindScheduleWithin90Days: number;
  openOnlySpecIndicator: number;
  awaitingPartsIndicator: number;
  onHoldIndicator: number;
  comments: string;
  excludedMod: number;
  optixObjectId: number;
  adaptEoTitle: string;
}
